import { boot } from 'quasar/wrappers';
import { useOrderStore } from '#src/store/order';
import useWebsocket from 'composables/websocket';

export default boot(({ router }) => {
  const orderStore = useOrderStore();

  orderStore.onRouteChange(router);
  const { ws } = useWebsocket();

  ws.on('order/update', (payload) => {
    orderStore.insertOrders(<OrderDataStore>payload);
    orderStore.setFailedToSync(false);
  });

  ws.on('order/failedToSync', () => {
    orderStore.setFailedToSync(true);
  });

  ws.on('order/claimProgress', (payload) => {
    orderStore.setClaimProgress(<{ orderNumber: string; finished: number; hasErrors: boolean; hasWarnings: boolean; total: number }>payload);
  });

  orderStore.getRecentlyShippedOrders();
});
